import { get } from 'lodash';
import { createSelector } from 'reselect';
import { DIET_ROUTE, DIET_TYPE } from './constants';

const toReadableDiet = diet => ({
  ...diet,
  route: DIET_ROUTE.toString(diet.routeId),
  type: DIET_TYPE.toString(diet.typeId),
});

const dietSliceSelector = state => get(state, ['dal', 'diet']);

export const dietSelector = createSelector(
  [dietSliceSelector],
  dietList => dietList.map(toReadableDiet),
);



// WEBPACK FOOTER //
// ./src/lib/dataLayer/diet/selectors.js